var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "box-modal-container", on: { click: _vm.closeBoxModal } },
    [
      _c(
        "div",
        {
          staticClass: "page4-container",
          on: {
            click: function($event) {
              $event.stopPropagation()
            }
          }
        },
        [
          _vm._m(0),
          _vm._v(" "),
          _vm.bestBoxes.length > 0
            ? _c(
                "ul",
                { staticClass: "boxes-container" },
                _vm._l(_vm.bestBoxes, function(box) {
                  return _c("li", { key: box.id }, [
                    _c("div", { staticClass: "box-container" }, [
                      _c(
                        "div",
                        {
                          staticClass: "main-image-container",
                          class: _vm.selectedBox.id == box.id ? "selected" : ""
                        },
                        [
                          _vm.selectedBox.id == box.id
                            ? _c("img", {
                                staticClass: "green-check",
                                attrs: {
                                  src:
                                    "https://cdn.shopify.com/s/files/1/1363/8433/files/check-circle.svg?v=1658433688"
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c("img", {
                            staticClass: "main-image lazyload",
                            attrs: {
                              "data-src": _vm._f("getProductImage")(box)
                            },
                            on: {
                              click: function($event) {
                                return _vm.selectBox(box)
                              }
                            }
                          })
                        ]
                      ),
                      _vm._v(" "),
                      _c("p", { staticClass: "box-title" }, [
                        _vm._v(_vm._s(box.title))
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "box-desc" }, [
                        _vm._v(_vm._s(_vm._f("moneyFormat")(box)))
                      ])
                    ])
                  ])
                }),
                0
              )
            : _vm._e()
        ]
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "page4-header", attrs: { id: "header-container" } },
      [
        _c("p", { staticClass: "main-title" }, [_vm._v("Gift Box Design")]),
        _vm._v(" "),
        _c("p", { staticClass: "main-subtitle" }, [
          _vm._v("Please pick a box design! Our boxes will "),
          _c("img", {
            attrs: {
              src:
                "https://cdn.shopify.com/s/files/1/1363/8433/files/sparkle_5257b419-6ffa-4278-bd91-46864bc15443.svg?v=1656613004"
            }
          }),
          _vm._v(" automagically "),
          _c("img", {
            attrs: {
              src:
                "https://cdn.shopify.com/s/files/1/1363/8433/files/sparkle_5257b419-6ffa-4278-bd91-46864bc15443.svg?v=1656613004"
            }
          }),
          _vm._v(" change sizes to ensure the perfect fit!")
        ])
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }